import { HttpResponse } from "@dirootie-core/http-types";
import { UserProfile } from "@dirootie-domain/iam";
import { application } from "../../../_runtime/bootstrap";
import { ActionButton } from "../../../components-common/buttons/ActionButton";
import { useEffect, useState } from "react";
import { CustomInput, Modal, Table } from "taltech-styleguide";
import { useModal } from "@components-common/modals";
import { useLocation, useParams } from "react-router-dom";
import { useNotifications } from "@hooks";
import { useQuery } from "react-query";

type CourseMember = {
  id: string;
  userId: string;
  displayName: string;
  email: string;
  user: UserProfile;
};

export const AddStudentToAssignment = () => {
  const userNotifications = useNotifications();
  const { id, assignmentId } = useParams();
  const { hideModal } = useModal();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedStudents, setSelectedStudents] = useState<string[]>([]);
  const { data: students, isFetching } = useQuery(
    `selectedStudents&${searchTerm}`,
    () => {
      return application
        .getHttpClient()
        .get(
          `/coursesms/members/invitations-assignment?courseId=${id}&assignmentId=${assignmentId}&displayName=${searchTerm}`
        )
        .then((x: HttpResponse) => {
          return x.body || [];
        });
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const AddSelectedUsers = () => {
    if (selectedStudents.length === 0) {
      userNotifications.error({ title: "Please select at least one student" });
      return;
    }
    setIsLoading(true);
    selectedStudents.forEach((studentId: string, index: number) => {
      const newStudent = {
        courseId: id,
        assignmentId,
        userId: studentId,
        state: "ACTIVE",
      };

      application
        .getHttpClient()
        .post(`/coursesms/assignments/members`, newStudent)
        .then((x: HttpResponse) => {
          if (x.statusCode === 200) {
            students.filter((student: UserProfile) => student.id !== studentId);
          }
          if (index === selectedStudents.length - 1) {
            setIsLoading(false);
            const newEvent = new CustomEvent("refetchTable");
            document.dispatchEvent(newEvent);
            hideModal();
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    });
  };

  return (
    <>
      <Modal.Header closeButton={false}>
        Add students to assignments
      </Modal.Header>
      <Modal.Body>
        <div className="w-100" style={{ height: "500px" }}>
          <div className="tt-input__control mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search for user"
              onInput={(e: any) => {
                if (e.target.value.length >= 3) {
                  setSearchTerm(e.target.value);
                } else {
                  setSearchTerm("");
                }
              }}
            />
          </div>
          {isLoading || isFetching ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              Loading...
            </div>
          ) : (
            <div style={{ maxHeight: "439px" }} className="overflow-auto">
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Full Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student: CourseMember) => (
                    <tr key={student.id}>
                      <td style={{ minWidth: "unset", maxWidth: "25px" }}>
                        <CustomInput
                          type="checkbox"
                          checked={selectedStudents.includes(student.userId)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedStudents([
                                ...selectedStudents,
                                student.userId,
                              ]);
                            } else {
                              setSelectedStudents(
                                selectedStudents.filter(
                                  (id: string) => id !== student.userId
                                )
                              );
                            }
                          }}
                        />
                      </td>
                      <td>{student.user.displayName}</td>
                      <td>{student.email}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between border-top">
        <ActionButton kind="close" onAction={hideModal} />
        <ActionButton
          kind="add"
          isLoading={isLoading}
          onAction={AddSelectedUsers}
        />
      </Modal.Footer>
    </>
  );
};
